// extracted by mini-css-extract-plugin
export default {"slot-label-content__container":"styles_slot-label-content__container__ZAlSP"};